import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Field } from "formik";
import { useStripe } from '@stripe/react-stripe-js';
import Button from 'web/components/Button';
import DebitForm from 'web/pages/private/CommonPages/ManageAccount/AddCardPopup/Credit-Card/debit-form/debitForm';
import RadioButton from "web/components/form-elements/RadioButton";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { KEY } from 'web/components/utils/stripeKey';
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { fetchLanguageContentNew } from "redux/actions/language";
import { paymentMethodCreate, paymentMethodProfileCreate } from 'redux/actions/payment';
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './popup.scss';

export default ({ isOpen, pageData, modalType, toggle, response, callBackModal, type, onClickHander }) => {

  const dispatch = useDispatch();
  const stripe = useStripe();
  let history = useHistory();
  const stripePromise = loadStripe(KEY);
  const token = localStorage.getItem("token");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  const [paymentType, setPaymentType] = useState("bankAccount");

  useEffect(() => {
    if (response?.forBuying?.debitCards?.length > 0) setPaymentType('bankAccount')
    else setPaymentType('creditCard')

    if (languageContentNew?.H8_Nav_Payment_Page) setPageLanguageContents(languageContentNew.H8_Nav_Payment_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const radioTypes = [
    {
      value: "bankAccount",
      label: "ACH",
    },
    {
      value: "creditCard",
      label: "Card",
    }
  ];

  const getRegisterInitialValues = (obj) => {
    return {
      accountHolderName: '',
      bankAccount: '',
      bankRouting: '',
      accountType: paymentType
    }
  }
  const VALIDATION_SCHEMA = Yup.object().shape({
    accountHolderName: Yup.string().trim().required('Please enter account holder name.'),
    bankAccount: Yup.string().trim().required('Please enter account number.'),
    bankRouting: Yup.string().trim().required('Please enter routing number.')
  });

  const onChangeHandler = (e, setFieldValue) => {
    if (type === "profile") {
      if (response?.forBuying?.debitCards?.length > 0) {
        setFieldValue('accountType', e.target.value)
        setPaymentType(e.target.value);
      } else if (e.target.value !== 'creditCard') {
        setFieldValue('accountType', 'creditCard')
        setPaymentType('creditCard');
        setModalContent('Please add a card before adding ACH account.');
        setModalLink("")
        toggleModal();
      } else {
        setFieldValue('accountType', 'creditCard')
        setPaymentType('creditCard');
      }
    }
  };

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='card-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              setPaymentType("bankAccount")
              if (modalType === "buyerToBothBuySellConversion" || modalType === "sellerToBothBuySellConversion") {
                onClickHander('close')
              } else {
                onClickHander()
              }
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>Card Details</h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className='modal-content'>
              <Formik
                validateOnMount
                enableReinitialize={true}
                initialValues={getRegisterInitialValues()}
                validationSchema={VALIDATION_SCHEMA}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  const { values, setFieldValue, isValid, dirty } = props;
                  return (
                    <Form className="form">
                      <div><div class="app-input-text"></div></div>
                      <div className="col-12 displayFlex">
                        <div>
                          {/* two options is shown only to let the user know there are ach and card options, */}
                          {/* but only card data is collected in this page as it is mandatory to add one card before ach account */}
                          {radioTypes &&
                            radioTypes.map((value, index) => (
                              <div key={index}>
                                <Field
                                  component={RadioButton}
                                  name="accountType"
                                  className="radio-label"
                                  id={value.value}
                                  defaultValue={radioTypes[0].value}
                                  onSelect={(e) => onChangeHandler(e, setFieldValue)}
                                  label={value.label}
                                  checked={value.value === paymentType}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                      {paymentType === "creditCard" &&
                        <DebitForm
                          paymentType={paymentType}
                          modalType={modalType}
                          pageData={pageData}
                          type="buyerSeller"
                          callBackModal={callBackModal}
                          callBackFetchApi={() => {
                            onClickHander("payment")
                          }}
                          callBack={() => { }}
                          pageLanguageContents={pageLanguageContents} />
                      }
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
      </Modal>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};